import { RoutingHistoryService } from './routingHistory.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { StreamService } from '.';
import * as _ from 'lodash';
import { map, tap, first } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class IsSourceGuard implements CanActivate {
    constructor(private router:Router, private streamService: StreamService, private routingHistoryService: RoutingHistoryService) { }

    canActivate = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        const topicId = this.topicIdFor(route);
        return topicId ? 
        this.streamService.getStream(topicId).pipe(
            first(),
            map(stream => stream.type !== 'COLLECTION'),
            tap(isSource => {
                if (!isSource) {
                    this.router.navigateByUrl(this.routingHistoryService.getPreviousUrl());
                }
            })
        ) :
        false;
    };

    topicIdFor(route: ActivatedRouteSnapshot): string {
        return route.params.topicId || (route.parent ? this.topicIdFor(route.parent) : undefined);
    }
}
